import { Plugin, ButtonView, toWidget } from 'ckeditor5';

export default class ZoomablePlugin extends Plugin {
    static get pluginName() {
        return 'ZoomablePlugin';
    }

    init() {
        this._defineSchema();
        this._defineConverters();

        this.editor.ui.componentFactory.add('zoomable', locale => {
            const buttonView = new ButtonView(locale);
            buttonView.set({
                label: 'Zoomable',
                icon: `<?xml version="1.0" encoding="UTF-8"?>
                    <svg id="zoomable_icon" data-name="zoomable icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 341.11 226.84">
                      <defs>
                        <style>
                          .cls-1 {
                            fill: #fff;
                          }

                          .cls-1, .cls-2, .cls-3 {
                            stroke-width: 0px;
                          }

                          .cls-2 {
                            fill: #42536d;
                          }

                          .cls-3 {
                            fill: #43556e;
                          }
                        </style>
                      </defs>
                      <g id="zoomable_icon-2" data-name="zoomable icon">
                        <g>
                          <path class="cls-2" d="m156.96,34.81c0-5.22,0-10.43-.02-15.65,0-1.76.14-1.62-1.64-1.62-4.52,0-9.05,0-13.57,0-.58,0-1.17-.04-1.75-.06-.13-.08-.25-.17-.38-.25-.19-.46-.11-.94-.11-1.42,0-4.67,0-9.34,0-14.02,0-.51-.16-1.07.22-1.53,46.05,0,92.09,0,138.14,0,.37,0,.75-.01,1.12-.02,0,0,0,0,0,0,.24.37.62.33.99.34.99.02,1.97.1,2.96.23,1.34.18,2.67.59,4.04.41.11.02.23.04.34.06.35.4.82.23,1.25.26,1.67.1,3.24.65,4.81,1.12,8.91,2.62,16.94,6.92,24.07,12.89,6.54,5.47,11.79,11.98,15.85,19.47,3.56,6.58,5.87,13.59,7.07,20.96.52,3.21.84,6.44.73,9.7-.06,1.97.04,3.94-.12,5.92-.63,7.77-2.52,15.22-5.74,22.33-2.72,6.02-6.29,11.5-10.66,16.45-5.57,6.3-12.1,11.36-19.6,15.2-5.64,2.88-11.55,4.94-17.77,6.12-2.41.46-4.83.74-7.28.97-1.87.17-3.73.16-5.59.16-23.27,0-46.53,0-69.8,0-.43,0-.85,0-1.28,0-1.22,0-1.24-.02-1.23,1.24,0,.43,0,.85,0,1.28,0,29.78,0,59.56,0,89.35,0,2.36.28,2.15-2.12,2.15-19.42,0-38.85,0-58.27,0-2.39,0-2.14.23-2.15-2.13,0-4.64,0-9.29,0-13.93,0-1.43-.04-1.4,1.41-1.4,4.75,0,9.5,0,14.25,0,.43,0,.85,0,1.28-.02.31-.01.48-.19.5-.5.02-.32.02-.64.02-.96,0-4.8,0-9.61,0-14.41,0-.32,0-.64-.02-.96-.01-.31-.19-.49-.49-.51-.43-.03-.85-.02-1.28-.03-4.59,0-9.18,0-13.77,0-.58,0-1.17.11-1.74-.14-.27-.56-.15-1.16-.15-1.74-.01-4.59,0-9.18-.01-13.77,0-.58.13-1.18-.17-1.73-.52-.19-1.06-.1-1.59-.11-4.7,0-9.39,0-14.09,0-.53,0-1.07-.03-1.6-.04,0,0,.03.03.03.03,0-5.43-.01-10.86-.02-16.29,0-.36-.08-.75.23-1.04.26.01.53.04.79.04,10.79,0,21.59,0,32.38,0,.32,0,.64.02.95-.03.19-.03.36-.18.55-.28,0-5.46-.02-10.92-.02-16.37,0-.21.05-.42.08-.63,2.97,0,5.93.01,8.9.01,2.33,0,4.66,0,6.99,0,.46,0,.97.13,1.34-.29.03-.32.08-.63.08-.95,0-5.16,0-10.32,0-15.48,0-.32-.05-.63-.08-.95-.45-.41-1.01-.25-1.52-.25-3.7-.01-7.41,0-11.11,0-1.22,0-2.43,0-3.65,0-.37,0-.75-.03-1,.34,0,1.97,0,3.93,0,5.9,0,3.4,0,6.8,0,10.2,0,.4.14.86-.25,1.18,0,0,.03-.02.03-.02-.21.02-.42.06-.63.06-5.16,0-10.31,0-15.47,0-.21,0-.43,0-.64-.02-.3-.03-.49-.18-.5-.5-.01-.42-.02-.85-.02-1.27,0-4.63,0-9.25,0-13.88,0-.58.09-1.17-.11-1.74-.46-.39-1.01-.24-1.52-.24-4.02-.01-8.05,0-12.07,0-.95,0-1.91,0-2.86,0-.33,0-.64.04-.83.35,0,11.05,0,22.1,0,33.14,0,.48-.06.95-.1,1.43-5.72,0-11.45-.01-17.17-.02-.36-.53-.2-1.14-.21-1.71-.02-4.58,0-9.17-.02-13.75,0-.62.16-1.29-.29-1.85-1.25-.32-2.51-.31-3.79-.31-4.42.01-8.84,0-13.26,0-.02-.32-.07-.63-.07-.95,0-4.92,0-9.84,0-14.76,0-.32.05-.63.07-.95,2.56,0,5.11,0,7.67,0,2.66,0,5.33,0,7.99,0,.54,0,1.07.02,1.51-.37.23-.5.18-1.04.18-1.56,0-4.77,0-9.53,0-14.3,0-.57.11-1.17-.26-1.69-.26,0-.53-.01-.79-.01-4.82,0-9.63,0-14.45,0-.63,0-1.28.1-1.84-.3-.02-.42-.07-.85-.07-1.27,0-10.48,0-20.95,0-31.43,0-.42.04-.85.07-1.27.57-.4,1.22-.3,1.86-.3,5.17,0,10.34,0,15.5-.01.02.58.07,1.17.07,1.75,0,4.52,0,9.04,0,13.57,0,.64.04,1.27.07,1.91.13.17.25.36.49.37.42.02.85.02,1.28.02,5.16,0,10.33,0,15.49,0,.02.42.07.85.07,1.27,0,5.22,0,10.45,0,15.67.28.44.73.35,1.15.35,5.03,0,10.06,0,15.09,0,.37,0,.75.04,1.04-.26.2-.57.11-1.16.11-1.74,0-4.58,0-9.16.01-13.74,0-.53-.11-1.07.12-1.58l.4-.28c.37-.03.74-.07,1.1-.07,4.87,0,9.73,0,14.6,0,.32,0,.63.04.95.06q.27.18.34-.27c0-5.69-.01-11.38-.02-17.08-.45-.43-1.01-.27-1.52-.27-5.21,0-10.42,0-15.63,0-.13-.08-.28-.15-.29-.34-.02-.53-.05-1.06-.05-1.59,0-4.56,0-9.11,0-13.67,0-.58.08-1.17-.1-1.74-.33-.37-.77-.29-1.19-.29-5.35,0-10.69,0-16.04.01-.03-.42-.08-.85-.08-1.27,0-10.58,0-21.16,0-31.75,0-.42.05-.85.08-1.27,5.76,0,11.53-.02,17.29-.03.23.51.12,1.04.12,1.57,0,4.6,0,9.21.01,13.81,0,.58-.11,1.17.13,1.73.48.36,1.03.21,1.55.21,3.9.01,7.79,0,11.69,0,1.07,0,2.13,0,3.2,0,.33,0,.64-.04.84-.35Zm82.84,15.12c-11.85,0-23.69,0-35.54,0-.43,0-.85,0-1.28,0-.86.02-.91.06-.93.9-.01.43,0,.85,0,1.28,0,9.66,0,19.32,0,28.98,0,.68-.28,1.52.18,2.01.52.55,1.41.23,2.14.23,23.32.01,46.64,0,69.95.02,2.05,0,4.04-.31,5.98-.88,7.21-2.11,12.71-9,11.74-17.96-.43-3.95-2.16-7.31-5.09-10.06-3.14-2.95-6.84-4.5-11.12-4.51-12.01-.03-24.01-.01-36.02-.01Z"/>
                          <path class="cls-3" d="m87.24,139.25c4.42,0,8.84,0,13.26,0,1.27,0,2.54,0,3.79.31-.53.02-1.06.07-1.59.07-4.37,0-8.75,0-13.12,0-.37,0-.75,0-1.12,0-1.22.03-1.24.03-1.24,1.27,0,4.86,0,9.71,0,14.57,0,1.8.13,1.64-1.63,1.64-10.19,0-20.38,0-30.57,0-.37,0-.75,0-1.12,0-1.71,0-1.55-.05-1.56,1.56,0,4.7,0,9.39,0,14.09,0,.48,0,.96-.03,1.44-.01.16-.18.24-.35.24,0-5.17,0-10.34,0-15.52,0-1.76.05-1.73-1.78-1.73-3.79,0-7.57,0-11.36,0-.8,0-1.6,0-2.4.03-.54.02-.86.65-1.45.61-.12-.43-.04-.75.48-.77.43-.02.85-.01,1.28-.01,4.58,0,9.16,0,13.73,0,.32,0,.64,0,.96,0,.77-.03.84-.09.87-.8.01-.27,0-.53,0-.8,0-4.74,0-9.48,0-14.22,0-.37,0-.75-.03-1.12-.02-.31-.21-.46-.51-.47-.43,0-.85-.02-1.28-.02-4.63,0-9.26,0-13.89,0-.43,0-.85.02-1.28-.01-.45-.04-.47-.33-.33-.68.58.36,1.22.33,1.86.33,4.48,0,8.95,0,13.43,0,.37,0,.75,0,1.12-.04.29-.03.5-.21.53-.51.04-.37.04-.74.04-1.12,0-4.42,0-8.85,0-13.27,0-1.75.04-1.72-1.79-1.72-5.06,0-10.13,0-15.19,0,0-.17.05-.36.22-.37.48-.04.95-.05,1.43-.05,4.59,0,9.17,0,13.76,0,.58,0,1.17.09,1.74-.12.28-.5.16-1.04.16-1.57,0-4.59,0-9.17,0-13.76,0-.43,0-.85,0-1.28.02-.62.12-.72.78-.73,1.39-.02,2.77,0,4.16,0,3.63,0,7.25,0,10.88,0,.32,0,.64,0,.96,0,.54.02.68.15.72.64.02.21,0,.43,0,.64,0,4.96,0,9.92,0,14.88,0,.21,0,.43,0,.64-.03.53-.16.68-.65.71-.43.02-.85.01-1.28.01-4.53,0-9.06,0-13.6,0-.48,0-.96,0-1.44.03-.31.01-.47.2-.48.51,0,.16-.01.32-.01.48,0,5.17,0,10.35,0,15.52,0,.21.04.42.06.61.34.3.72.22,1.08.22,10.88,0,21.75,0,32.63,0,.4,0,.87.15,1.14-.34Z"/>
                          <path class="cls-3" d="m95.97,17.52c2.35,0,4.69,0,7.04,0,.37,0,.75,0,1.12.02.29.02.5.17.52.49.02.32.03.64.03.96,0,4.85,0,9.71,0,14.56,0,.32,0,.64-.03.96-.02.23-.17.4-.4.42-.42.04-.85.05-1.28.05-4.59,0-9.17,0-13.76,0-.43,0-.85,0-1.28.01-.59.03-.7.15-.72.79-.02.43,0,.85,0,1.28,0,4.53,0,9.07,0,13.6,0,.43,0,.85-.03,1.28-.02.31-.22.46-.52.48-.21.01-.43.02-.64.02-5.07,0-10.13,0-15.2,0-.21,0-.43,0-.64-.03-.24-.03-.38-.19-.4-.42-.03-.32-.05-.64-.05-.96,0-4.91,0-9.81,0-14.72,0-.05,0-.11,0-.16.02-1.22.02-1.23,1.26-1.23,4.85,0,9.71,0,14.56,0,1.78,0,1.62.14,1.62-1.64,0-4.64,0-9.28,0-13.92,0-.43,0-.85.02-1.28,0-.3.16-.5.47-.52.37-.02.75-.03,1.12-.03,2.4,0,4.8,0,7.2,0Z"/>
                          <path class="cls-2" d="m122.05,192.11c-.62-.21-1.27-.11-1.9-.11-10.34,0-20.68,0-31.02,0-2.23,0-1.95.2-1.96-1.97-.01-4.58,0-9.17,0-13.75,0-.43,0-.85.02-1.28.01-.31.21-.48.51-.49.48-.02.96-.02,1.44-.02,10.98,0,21.96,0,32.93,0,0,0-.03-.03-.03-.03.01,5.47.02,10.95.03,16.42,0,.42-.03.85-.05,1.27l.03-.03Z"/>
                          <path class="cls-3" d="m122.14,52.15c5.35,0,10.69-.01,16.04-.01.42,0,.86-.08,1.19.29-5.17,0-10.33,0-15.5.01-.43,0-.85,0-1.28.02-.31.01-.48.19-.49.5-.01.43-.02.85-.02,1.28,0,4.64,0,9.27,0,13.91,0,.52.1,1.06-.12,1.58-.57.25-1.16.13-1.74.14-4.63.01-9.27,0-13.9.01-.57,0-1.18-.14-1.71.2-5.17,0-10.34,0-15.5.01-.63,0-1.29-.1-1.86.3-.01-.21-.03-.47.23-.51.47-.06.96-.06,1.43-.06,4.69,0,9.39,0,14.08,0,1.78,0,1.6.13,1.6-1.67,0-4.64,0-9.28,0-13.92,0-.43,0-.85.02-1.28,0-.3.16-.5.48-.51.43-.02.85-.02,1.28-.02,4.75,0,9.49,0,14.24,0,.52,0,1.07.15,1.53-.24Z"/>
                          <path class="cls-3" d="m52.24,69.44c.1.21.26.34.49.35.43.02.85.02,1.28.02,4.59,0,9.17,0,13.76,0,.37,0,.75,0,1.12,0,.84.03.91.07.91.94,0,4.37,0,8.75,0,13.12,0,.85.01,1.71,0,2.56-.02.8-.1.88-.95.89-.8.01-1.6,0-2.4,0-4.05,0-8.11,0-12.16,0-.43,0-.85,0-1.28,0-.55-.02-.68-.14-.7-.64-.02-.43-.01-.85-.01-1.28,0-4.69,0-9.39,0-14.08,0-1.56.04-1.45-1.5-1.45-4.69,0-9.39,0-14.08,0-.53,0-1.07.11-1.58-.1,5.09,0,10.18,0,15.27,0,.64,0,1.28.06,1.85-.31Z"/>
                          <path class="cls-3" d="m26.07,104.72c-2.61,0-5.22,0-7.83,0-.74,0-.82-.09-.83-.83,0-4,0-7.99,0-11.99,0-1.28,0-2.56,0-3.84,0-.62.12-.71.76-.75.21-.01.43,0,.64,0,4.9,0,9.81,0,14.71,0,1.46,0,1.4.04,1.4,1.41,0,4.85,0,9.7,0,14.55,0,.32,0,.64-.02.96-.01.33-.23.47-.52.49-.37.02-.75.02-1.12.02-2.4,0-4.8,0-7.19,0h0Z"/>
                          <path class="cls-2" d="m8.72,122.31c-2.35,0-4.69,0-7.04,0-.37,0-.75,0-1.12-.01-.4,0-.55-.25-.55-.61,0-.27,0-.53,0-.8,0-4.85,0-9.71,0-14.56,0-.21,0-.43,0-.64.03-.69.09-.76.71-.79.16,0,.32,0,.48,0,5.01,0,10.03,0,15.04,0,.21,0,.43,0,.64.01.41.01.55.26.55.62,0,.27,0,.53,0,.8,0,4.85,0,9.71,0,14.56,0,.21,0,.43,0,.64-.03.67-.1.76-.71.78-.37.02-.75,0-1.12,0-2.29,0-4.59,0-6.88,0Z"/>
                          <path class="cls-2" d="m122.02,192.14c.32-.25.71-.2,1.08-.2,5.06,0,10.12,0,15.18,0,.27,0,.53.01.8.05.23.03.39.17.41.41.03.32.05.64.05.96,0,4.9,0,9.8,0,14.7,0,.27,0,.53-.02.8-.02.3-.16.5-.48.51-.32.02-.64.02-.96.02-4.85,0-9.69,0-14.54,0-.32,0-.64,0-.96-.02-.31-.01-.49-.18-.5-.49-.02-.43-.02-.85-.02-1.28,0-5.17,0-10.33,0-15.5,0,0-.03.03-.03.03Z"/>
                          <path class="cls-2" d="m52.24,69.44c-.57.37-1.21.31-1.85.31-5.09,0-10.18,0-15.27,0-.22-.2-.23-.46-.23-.73,0-5.26,0-10.52,0-15.78,0-.16.05-.31.08-.47,5.75,0,11.51,0,17.26,0,.03.31.08.63.08.94,0,4.92,0,9.84,0,14.77,0,.32-.05.63-.07.95Z"/>
                          <path class="cls-2" d="m34.96,157.82c.59.04.9-.58,1.45-.61.8-.04,1.6-.03,2.4-.03,3.79,0,7.57,0,11.36,0,1.83,0,1.78-.03,1.78,1.73,0,5.17,0,10.34,0,15.52-.32.02-.63.07-.95.07-4.92,0-9.84,0-14.76,0-.32,0-.63-.04-.95-.06-.11-.09-.21-.19-.32-.28-.03-.31-.08-.63-.08-.94,0-4.81,0-9.63,0-14.44,0-.31.05-.63.08-.94Z"/>
                          <path class="cls-2" d="m34.96,122.59c5.06,0,10.13,0,15.19,0,1.82,0,1.79-.03,1.79,1.72,0,4.42,0,8.85,0,13.27,0,.37,0,.75-.04,1.12-.03.3-.24.48-.53.51-.37.03-.74.04-1.12.04-4.48,0-8.95,0-13.43,0-.64,0-1.28.04-1.86-.33-.03-.31-.08-.63-.08-.94,0-4.81,0-9.63,0-14.44,0-.31.05-.63.08-.94Z"/>
                          <path class="cls-3" d="m278.97.24c-.37,0-.75.02-1.12.02-46.05,0-92.09,0-138.14,0,.13-.07.27-.19.4-.2.48-.03.96-.02,1.44-.02,45.13,0,90.26,0,135.39,0,.67,0,1.38-.19,2.02.19Z"/>
                          <path class="cls-3" d="m156.97,156.87c-.18.1-.35.25-.55.28-.31.05-.64.03-.95.03-10.79,0-21.59,0-32.38,0-.27,0-.53-.02-.79-.04-3.41-.01-6.82-.03-10.23-.04-2.13,0-4.26,0-6.4,0-.3,0-.65.1-.86-.24,5.72,0,11.45.01,17.17.02.51.24,1.05.16,1.58.16,10.61,0,21.23,0,31.84,0,.53,0,1.07.07,1.58-.16Z"/>
                          <path class="cls-3" d="m104.41,122.22c-.44.39-.97.38-1.51.37-2.66,0-5.33,0-7.99,0-2.56,0-5.11,0-7.67,0-.02-.17.05-.34.21-.37.26-.05.53-.06.79-.06,5.18,0,10.35,0,15.53,0,.21,0,.42.03.64.05Z"/>
                          <path class="cls-3" d="m87.24,104.35c.56.4,1.21.3,1.84.3,4.82,0,9.63,0,14.45,0,.26,0,.53,0,.79.01-.37.02-.74.07-1.11.07-4.88,0-9.75,0-14.63,0-.37,0-.74,0-1.11-.04-.16-.02-.25-.17-.24-.35Z"/>
                          <path class="cls-3" d="m139.43,17.84c-5.76,0-11.53.02-17.29.03.04-.09.07-.24.13-.26.2-.06.42-.08.62-.08,5.25,0,10.49,0,15.74,0,.29,0,.66-.1.8.31Z"/>
                          <path class="cls-3" d="m156.96,34.81c-.2.31-.51.35-.84.35-1.07,0-2.13,0-3.2,0-3.9,0-7.79,0-11.69,0-.52,0-1.07.14-1.55-.21,5.12,0,10.24-.02,15.36-.03.64,0,1.28.07,1.91-.1Z"/>
                          <path class="cls-3" d="m52.23,52.78c-5.75,0-11.51,0-17.26,0,.06-.14.08-.31.28-.32.37-.02.74-.04,1.11-.04,4.83,0,9.65,0,14.48,0,.37,0,.74.02,1.11.04.2,0,.23.18.28.32Z"/>
                          <path class="cls-3" d="m286.96,1.21c-1.38.19-2.71-.23-4.04-.41-.99-.13-1.97-.21-2.96-.23-.37,0-.75.03-.99-.34,2.71-.02,5.37.34,7.99.98Z"/>
                          <path class="cls-3" d="m288.55,1.54c-.43-.04-.9.14-1.25-.26.45-.08.87.02,1.25.26Z"/>
                          <path class="cls-3" d="m139.61,17.22c.13.08.25.17.38.25-.21.04-.4.05-.38-.25Z"/>
                          <path class="cls-3" d="m34.97,174.15c.11.09.21.19.32.28-.22.04-.35-.03-.32-.28Z"/>
                          <path class="cls-1" d="m104.6,70.07c.54-.34,1.14-.2,1.71-.2,4.63-.01,9.27,0,13.9-.01.58,0,1.17.11,1.74-.14.22-.52.12-1.06.12-1.58,0-4.64,0-9.27,0-13.91,0-.43,0-.85.02-1.28,0-.31.18-.49.49-.5.43-.01.85-.02,1.28-.02,5.17,0,10.33,0,15.5-.01.18.57.1,1.16.1,1.74,0,4.56,0,9.11,0,13.67,0,.53.03,1.06.05,1.59,0,.19.16.25.29.34.51.21,1.05.1,1.57.1,4.62,0,9.24,0,13.85,0,.58,0,1.17-.09,1.73.16,0,5.69.01,11.38.02,17.08-.11.09-.22.18-.34.27-.32-.02-.63-.06-.95-.06-4.87,0-9.73,0-14.6,0-.37,0-.74.05-1.1.07-.23-.05-.38.01-.4.28-.23.51-.12,1.05-.12,1.58,0,4.58,0,9.16-.01,13.74,0,.58.09,1.17-.11,1.74-5.12,0-10.24,0-15.37-.02-.64,0-1.28-.05-1.92-.07,0-5.22,0-10.45,0-15.67,0-.42-.05-.85-.07-1.27,0-.17-.07-.33-.24-.35-.42-.04-.85-.05-1.27-.05-5.25,0-10.5,0-15.75,0-.02-.64-.07-1.27-.07-1.91,0-4.52,0-9.04,0-13.57,0-.58-.04-1.17-.07-1.75Z"/>
                          <path class="cls-1" d="m156.97,156.87c-.51.23-1.05.16-1.58.16-10.61,0-21.23,0-31.84,0-.53,0-1.07.09-1.58-.16.03-.48.1-.95.1-1.43,0-11.05,0-22.1,0-33.14.64-.03,1.28-.08,1.91-.08,5.12-.01,10.24-.02,15.37-.02.2.57.11,1.16.11,1.74,0,4.63,0,9.25,0,13.88,0,.43,0,.85.02,1.27.01.32.21.47.5.5.21.02.42.02.64.02,5.16,0,10.31,0,15.47,0,.21,0,.42-.04.63-.06.1.11.2.22.29.32-.03.21-.08.42-.08.63,0,5.46.01,10.92.02,16.37Z"/>
                          <path class="cls-1" d="m156.71,139.57c.39-.33.25-.78.25-1.18.01-3.4,0-6.8,0-10.2,0-1.97,0-3.93,0-5.9.59-.02,1.17-.06,1.76-.07,5.18,0,10.35,0,15.53,0,.03.32.08.63.08.95,0,5.16,0,10.32,0,15.48,0,.32-.05.63-.08.95-5.85,0-11.7-.02-17.55-.03Z"/>
                          <path class="cls-3" d="m104.74,87.29c5.25,0,10.5,0,15.75,0,.42,0,.85.01,1.27.05.17.01.24.18.24.35-5.16,0-10.33,0-15.49,0-.43,0-.85,0-1.28-.02-.24,0-.36-.19-.49-.37Z"/>
                          <path class="cls-3" d="m156.71,139.57c5.85,0,11.7.02,17.55.03-.38.42-.88.29-1.34.29-2.33.01-4.66,0-6.99,0-2.97,0-5.93,0-8.9-.01-.1-.11-.2-.22-.29-.32,0,0-.03.02-.03.02Z"/>
                          <path class="cls-3" d="m122.07,104.63c.64.02,1.28.07,1.92.07,5.12.01,10.24.01,15.37.02-.29.3-.67.26-1.04.26-5.03,0-10.06,0-15.09,0-.41,0-.86.09-1.15-.35Z"/>
                          <path class="cls-3" d="m139.36,122.2c-5.12,0-10.24,0-15.37.02-.64,0-1.28.05-1.91.08.2-.31.5-.35.83-.35.95,0,1.91,0,2.86,0,4.02,0,8.05,0,12.07,0,.51,0,1.07-.15,1.52.24Z"/>
                          <path class="cls-3" d="m174.26,122.21c-5.18,0-10.35,0-15.53,0-.59,0-1.17.04-1.76.07.25-.36.63-.33,1-.34,1.22,0,2.43,0,3.65,0,3.7,0,7.41,0,11.11,0,.51,0,1.07-.16,1.52.25Z"/>
                          <path class="cls-3" d="m156.96,70.02c-.56-.25-1.15-.16-1.73-.16-4.62,0-9.24,0-13.85,0-.52,0-1.06.11-1.57-.1,5.21,0,10.42,0,15.63,0,.51,0,1.07-.16,1.52.27Z"/>
                          <path class="cls-3" d="m156.65,87.37c.11-.09.22-.18.34-.27q-.06.45-.34.27Z"/>
                          <path class="cls-3" d="m139.59,87.66c.02-.26.17-.32.4-.28-.13.09-.27.18-.4.28Z"/>
                        </g>
                      </g>
                    </svg>`,
                tooltip: true
            });

            buttonView.on('execute', () => {
                const editor = this.editor;

                // force focus and ensure editor state is ready before file picker - critical for mobile devices
                let safePosition = null;

                editor.model.change(writer => {
                    const root = editor.model.document.getRoot();

                    // try stored position first
                    let position = editor.model.document.selection.getFirstPosition();

                    // if user never focused editor → position is null
                    if (!position || position.root !== root) {
                        position = writer.createPositionAt(root, 0);
                    }

                    writer.setSelection(position);

                    safePosition = position;
                });

                // force focus (needed for iOS)
                editor.editing.view.focus();

                // small delay for iOS to process focus before file picker
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = '.png,.jpg,.jpeg';
                input.multiple = true;

                input.style.position = 'absolute';
                input.style.opacity = '0';
                input.style.pointerEvents = 'none';

                document.body.appendChild(input);

                input.onchange = (event) => {
                    const files = Array.from(input.files);
                    if (!files.length) {
                        input.remove();
                        return;
                    }

                    const totalFiles = files.length;
                    const uploadPromises = [];

                    // show queue
                    let progressIndicator = null;
                    if (totalFiles > 1) {
                        progressIndicator = document.createElement('div');

                        const isMobile = window.innerWidth <= 768;

                        if (isMobile) {
                            progressIndicator.style.cssText = `
                                position: fixed;
                                top: 0;
                                left: 0;
                                right: 0;
                                background: #2196F3;
                                color: white;
                                padding: 15px 20px;
                                box-shadow: 0 -4px 12px rgba(0,0,0,0.3);
                                z-index: 10000;
                                font-family: Arial, sans-serif;
                                font-size: 14px;
                                font-weight: bold;
                                text-align: center;
                            `;
                        } else {
                            progressIndicator.style.cssText = `
                                position: fixed;
                                bottom: 20px;
                                right: 20px;
                                background: #2196F3;
                                color: white;
                                padding: 15px 20px;
                                border-radius: 8px;
                                box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                                z-index: 10000;
                                font-family: Arial, sans-serif;
                                font-size: 14px;
                                font-weight: bold;
                                min-width: 200px;
                            `;
                        }

                        progressIndicator.innerHTML = `Uploading images: 1/${totalFiles}`;
                        document.body.appendChild(progressIndicator);
                    }

                    // create all placeholders first to maintain order
                    const placeholders = [];
                    editor.model.change(writer => {
                        let position = safePosition

                        const root = editor.model.document.getRoot();

                        if (!position || position.root !== root) {
                            position = writer.createPositionAt(root, 0);
                        }

                        // create placeholders for all files
                        for (let i = 0; i < totalFiles; i++) {
                            const placeholder = writer.createElement('paragraph');
                            const placeholderText = totalFiles > 1
                                ? `[Uploading image ${i + 1} of ${totalFiles}…]`
                                : '[Uploading image…]';
                            writer.append(
                                writer.createText(placeholderText, { class: 'image-upload-placeholder' }),
                                placeholder
                            );
                            writer.insert(placeholder, position);
                            placeholders.push(placeholder);

                            // move position after the inserted placeholder for next one
                            position = writer.createPositionAfter(placeholder);
                        }
                    });

                    // upload files sequentially with delay between each to prevent filename collisions
                    const uploadSequentially = async () => {
                        let completedCount = 1;

                        for (let index = 0; index < files.length; index++) {
                            const file = files[index];
                            const placeholder = placeholders[index];

                            try {
                                const loader = editor.plugins.get('FileRepository').createLoader(file);
                                loader.isZoomable = true;

                                const data = await loader.upload();

                                editor.model.change(innerWriter => {
                                    const insertPos = innerWriter.createPositionBefore(placeholder);
                                    innerWriter.remove(placeholder);

                                    const zoomableDiv = innerWriter.createElement('div', {
                                        class: 'zoomable-image',
                                        'data-image-id': data.image_id
                                    });
                                    const figure = innerWriter.createElement('figure');
                                    const image = innerWriter.createElement('zoomableImage', {
                                        src: data.thumbnail || `/images/thumbs/${data.url || data.default}`,
                                        loading: 'lazy',
                                        alt: data.image_title
                                    });
                                    const caption = innerWriter.createElement('span', {
                                        class: 'image-caption',
                                        'data-image-id': data.image_id
                                    });
                                    innerWriter.append(
                                        innerWriter.createText(`i${data.image_id}`),
                                        caption
                                    );

                                    innerWriter.append(image, figure);
                                    innerWriter.append(caption, figure);
                                    innerWriter.append(figure, zoomableDiv);
                                    innerWriter.insert(zoomableDiv, insertPos);
                                });

                                // update queue
                                completedCount++;
                                if (progressIndicator) {
                                    progressIndicator.innerHTML = `Uploading images: ${completedCount}/${totalFiles}`;
                                }

                                // wait 1 second before starting next upload (except after the last one)
                                if (index < files.length - 1) {
                                    await new Promise(resolve => setTimeout(resolve, 1000));
                                }
                            } catch (error) {
                                editor.model.change(innerWriter => innerWriter.remove(placeholder));

                                completedCount++;
                                if (progressIndicator) {
                                    progressIndicator.innerHTML = `Uploading images: ${completedCount}/${totalFiles}`;
                                }
                            }
                        }
                    };

                    uploadPromises.push(uploadSequentially());

                    // remove input and queue after all uploads complete
                    Promise.all(uploadPromises).finally(() => {
                        input.remove();
                        if (progressIndicator) {
                            progressIndicator.remove();
                        }
                    });
                };

                input.oncancel = () => {
                    input.remove();
                };

                input.click();
            });

            return buttonView;
        });
    }

    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('div', {
            inheritAllFrom: '$block',
            allowAttributes: ['class', 'data-image-id'],
            allowContentOf: '$block'
        });

        schema.register('figure', {
            allowIn: 'div',
            allowContentOf: '$block'
        });

        schema.register('zoomableImage', {
            isObject: true,
            isBlock: true,
            allowIn: 'figure',
            allowAttributes: ['src', 'loading', 'alt']
        });

        schema.register('span', {
            allowIn: 'figure',
            allowAttributes: ['class', 'data-image-id'],
            allowContentOf: '$block'
        });
    }

    _defineConverters() {
        const conversion = this.editor.conversion;

        conversion.for('dataDowncast').elementToElement({
            model: 'div',
            view: (modelEl, { writer }) => writer.createContainerElement('div', {
                class:           modelEl.getAttribute('class'),
                'data-image-id': modelEl.getAttribute('data-image-id'),
                contenteditable: 'false'
            })
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'figure',
            view: (modelEl, { writer }) => writer.createContainerElement('figure', {
                contenteditable: 'false'
            })
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'zoomableImage',
            view: (modelEl, { writer }) => writer.createEmptyElement('img', {
                src:     modelEl.getAttribute('src'),
                loading: modelEl.getAttribute('loading') || 'lazy',
                alt:     modelEl.getAttribute('alt') || '',
                class:   'zoomable-image-thumb',
                contenteditable: 'false',
                draggable:       'false'
            })
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'span',
            view: (modelEl, { writer }) => writer.createContainerElement('span', {
                class:           modelEl.getAttribute('class') || 'image-caption',
                'data-image-id': modelEl.getAttribute('data-image-id'),
                contenteditable: 'false',
                draggable:       'false'
            })
        });

        // EDITING downcast
        conversion.for('editingDowncast').elementToElement({
            model: 'div',
            view: (modelEl, { writer }) => {
                const div = writer.createContainerElement('div', {
                    class:           modelEl.getAttribute('class'),
                    'data-image-id': modelEl.getAttribute('data-image-id'),
                    contenteditable: 'false'
                });
                return toWidget(div, writer);
            }
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'figure',
            view: (modelEl, { writer }) => writer.createContainerElement('figure', {
                contenteditable: 'false'
            })
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'zoomableImage',
            view: (modelEl, { writer }) => writer.createEmptyElement('img', {
                src:     modelEl.getAttribute('src'),
                loading: modelEl.getAttribute('loading') || 'lazy',
                alt:     modelEl.getAttribute('alt') || '',
                class:   'zoomable-image-thumb',
                contenteditable: 'false',
                draggable:       'false'
            })
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'span',
            view: (modelEl, { writer }) => writer.createContainerElement('span', {
                class:           modelEl.getAttribute('class') || 'image-caption',
                'data-image-id': modelEl.getAttribute('data-image-id'),
                contenteditable: 'false',
                draggable:       'false'
            })
        });

        conversion.for('upcast').elementToElement({
            view:  { name: 'div',    classes: 'zoomable-image' },
            model: (viewEl, { writer }) => writer.createElement('div', {
                class: 'zoomable-image',
                'data-image-id': viewEl.getAttribute('data-image-id')
            }),
            converterPriority: 'high'
        });

        conversion.for('upcast').elementToElement({
            view:  { name: 'figure' },
            model: (viewEl, { writer }) => writer.createElement('figure')
        });
        conversion.for('upcast').elementToElement({
            view:  { name: 'img', attributes: { src: true, loading: true } },
            model: (viewEl, { writer }) => writer.createElement('zoomableImage', {
                src:     viewEl.getAttribute('src'),
                loading: viewEl.getAttribute('loading') || 'lazy',
                alt:     viewEl.getAttribute('alt') || ''
            }),
            converterPriority: 'high'
        });
        conversion.for('upcast').elementToElement({
            view:  { name: 'span', classes: 'image-caption' },
            model: (viewEl, { writer }) => {
                // Get image-id from span or fallback to parent div
                let imageId = viewEl.getAttribute('data-image-id');
                if (!imageId) {
                    // span.parent is the <figure>, its parent is the <div.zoomable-image>
                    const figure = viewEl.parent;
                    const div = figure && figure.parent;
                    imageId = div && div.getAttribute('data-image-id');
                }
                return writer.createElement('span', {
                    class:           viewEl.getAttribute('class') || 'image-caption',
                    'data-image-id': imageId
                });
            }
        });
    }
}
